import React from "react";
import { Link } from "react-router-dom";
import GoogleAuth from "../GoogleAuth/GoogleAuth";
import { Image , Nav, Navbar } from "react-bootstrap";
import { connect } from "react-redux";

import logos from "./../../images/logos";
import UserNavItem from "./UserNavItem";
import LanguageSelector from "./LanguageSelector";

import "./Header.css";

const Header = (props) => {
  return (
    <Navbar bg="light" expand="md" className="header">
      <Navbar.Brand id="logo" as={Link} to="/">
        <Image id="logo-image" src={logos["logo2"]} />&nbsp;123Monkey
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link as={Link} to="#home">Home</Nav.Link>
          <Nav.Link as={Link} to="/maths/m1">Test</Nav.Link>
          <Nav.Link as={Link} to="/chinese/1">Chinese</Nav.Link>
        </Nav>
        <Nav>
          { props.isSignedIn && 
            <UserNavItem />
          }
          <GoogleAuth />
          <LanguageSelector />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

const mapStateToProps = (state) => {
  return { 
    isSignedIn: state.user.isSignedIn,
  };
}

export default connect(mapStateToProps)(Header);